import React from 'react';
import { useState } from "react";
import getUrl from "../../../../../Utility/GetUrl";
import { postData } from "../../../../../Utility/GlobalService";
import FileInput from "../../../Components/file-input";
import TextAreaInput from "../../../Components/textareaInput";
import TextInput from "../../../Components/textInput";

const AboutMe = ()=>{
    const [aboutMeTitle,setaboutMeTitle] = useState("");
    const [aboutMeContent,setaboutMeContent] = useState("");
    const [personImage,setpersonImage] = useState("");
    const handleaboutMeTitleSubmit = (event)=>{
        event.preventDefault();
        const data = {
            title: aboutMeTitle
        };
        postData(`${getUrl()}/aboutme/title`,data);
        setaboutMeTitle("");
    }
    const handleaboutMeContentSubmit = (event)=>{
        event.preventDefault();
        const data = {
            content: aboutMeContent
        };
        postData(`${getUrl()}/aboutme/content`,data);
        setaboutMeContent("");
    }
    const handlePersonImageUpload = (event)=>{
        event.preventDefault();
        let data = new FormData();
        data.append('personimage',personImage);
        postData(`${getUrl()}/aboutme/image`,data);
    }
    return (
        <div className="card">
            <div className="card-body mb-auto">
                <h5>About Me </h5>
                <TextInput
                    handleInputSubmit = {handleaboutMeTitleSubmit}
                    setInputValue = {setaboutMeTitle}
                    inputValue ={aboutMeTitle}
                />
                <FileInput
                    setFileinput = {setpersonImage}
                    handleFileUpload = {handlePersonImageUpload}
                />
                <TextAreaInput
                    handleSectionContent = {handleaboutMeContentSubmit}
                    sectioncontent = {aboutMeContent}
                    setSectionContent = {setaboutMeContent}
                />
            </div>
        </div>
    )
}
export default AboutMe;